export default __webpack_public_path__ + "static/media/mobile_dev_img.647e78e8.jpg";